import React, { useRef, useState } from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import { toPng } from "html-to-image";
import './SocialCardModal.css'

const SocialCardModal = ({ show, onHide, userProfile, infName }) => {
    const cardRef = useRef(null);
    const [downloading, setDownloading] = useState(false);

    if (!userProfile || !infName) {
        return (
            <Modal show={show} onHide={onHide} centered>
                <Modal.Body>Loading...</Modal.Body>
            </Modal>
        );
    }

    const getImageUrl = firebaseUrl => {
        if (!firebaseUrl) return "";
        return `https://us-central1-zindua-ke.cloudfunctions.net/downloadFile/image?url=${encodeURIComponent(firebaseUrl)}`;
    };

    const handleDownload = async () => {
        if (!cardRef.current) return;

        setDownloading(true);

        try {
            const dataUrl = await toPng(cardRef.current, {
                cacheBust: true,
                pixelRatio: 3,
                backgroundColor: "#fafafa",
                style: {
                    width: "360px",
                    height: "360px",
                    margin: "0",
                },
            });

            const link = document.createElement("a");
            link.download = `${infName}-zindua-card.png`;
            link.href = dataUrl;
            link.click();
        } catch (err) {
            console.error("Download failed", err);
        } finally {
            setDownloading(false);
        }
    };


    return (
        <div className="exportWrapper">
            <div ref={cardRef} className="socialCard export">

                <Modal show={show} onHide={onHide} centered className="socialCardModal">
                    <Modal.Body>
                        <div ref={cardRef} className="socialCard">
                            {userProfile.coverPhoto && (
                                <div
                                    className="socialCardBg"
                                    style={{
                                        backgroundImage: `url(${getImageUrl(userProfile.coverPhoto)})`,
                                    }}
                                />
                            )}

                            <div className="socialCardSafe">
                                {userProfile.profilePhoto && (
                                    <div className="socialAvatar">
                                        <img src={getImageUrl(userProfile.profilePhoto)} alt={infName} />
                                    </div>
                                )}

                                <h2 className="socialName">{infName}</h2>
                                <p className="socialCountry">{userProfile.country || "Unknown Country"}</p>

                                <div className="myborder"></div>

                                <p className="socialTagline">
                                    Officially on Zindua App
                                    <br />
                                    Accepting brand deals now
                                    <br/><br/><br/>
                                    zindua.app/{userProfile.profileLink}
                                </p>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="light" onClick={onHide} disabled={downloading}>
                            Close
                        </Button>

                        <Button
                            className="downloadBtn"
                            onClick={handleDownload}
                            disabled={downloading}
                        >
                            {downloading ? (
                                <>
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                    Downloading...
                                </>
                            ) : (
                                "Download Card"
                            )}
                        </Button>
                    </Modal.Footer>

                </Modal>
            </div>
        </div>

    );
};

export default SocialCardModal;